import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import DataTable from '../common/DataTable';
import { RateCardHistoryColumns, CustomServiceChangeHistoryColumns } from '../../constant';
import { getServicesByRateCardHistory, getCustomServiceChangeHistory } from '../../store/actions/serviceRateCard.action';
import PropTypes from 'prop-types';

const toLocalText = (value) => (value ? moment.utc(value).local().format('MM-DD-YYYY, h:mm A') : '');

/* istanbul ignore next */
export default function RateCardHistoryDialog(props) {
    const { modalShow, setModalShow, rateCardDetails } = props;
    const [rateCardListData, setRateCardListData] = React.useState([]);
    const [changeHistoryData, setChangeHistoryData] = React.useState([]);
    const isCustomService = !!modalShow.item?.IsCustomService;

    useEffect(() => {
        if (modalShow.show) {
            fetchRateCardHistory();
            if (isCustomService) {
                fetchCustomServiceChangeHistory();
            }
        }
    }, [modalShow.show]);

    const fetchCustomServiceChangeHistory = async () => {
        try {
            const response = await getCustomServiceChangeHistory(rateCardDetails.CompanySellerId, modalShow.item.AccountingServiceMaster_Id);
            if (response?.data?.Status === 200) {
                setChangeHistoryData((response.data.EntityList || []).map((row) => ({
                    ...row,
                    CreatedDate: toLocalText(row.CreatedDate),
                })));
            }
        } catch (error) {
            console.error("Error fetching custom service change history:", error);
        }
    };

    const fetchRateCardHistory = async () => {
        try {
            // Simulating an API call to fetch rate card history
            let historyPayload = `${rateCardDetails.CompanySellerId}/${modalShow.item.AccountingServiceMaster_Id}`;
            const response = await getServicesByRateCardHistory(historyPayload); // Replace with actual API endpoint
            if (response?.data?.Status === 200) {
                setRateCardListData((response.data.EntityList || []).map((row) => ({
                    ...row,
                    ValidFrom: toLocalText(row.ValidFrom),
                    ValidTo: toLocalText(row.ValidTo),
                })));
            }
        } catch (error) {
            console.error("Error fetching rate card history:", error);
        }
    };

    return (
        <Modal
            size="lg"
            show={modalShow.show}
            onHide={() => {
                setModalShow({ show: false, item: null });
            }}
            centered>
            <Modal.Header >
                <div className="modal-main-div">
                    <h6 >History</h6>
                </div>
                <div className="modalDeleteWrapper">
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => setModalShow({ show: false, item: null })}></button>
                </div>
            </Modal.Header>
            <Modal.Body className='fontFix'>
                <div className='row mb-3'>
                    <div className='col-4'>
                        <div>Service Type: <b>{modalShow.item.ServiceType}</b></div>
                        <div>Transaction Type: <b>{modalShow.item.TransactionType}</b></div>
                    </div>
                    <div className='col-4'>
                        <div>Charge Type: <b>{modalShow.item.PackingType}</b></div>
                        <div>Size Type: <b>{modalShow.item.SizeType}</b></div>
                    </div>
                    <div className='col-4'>
                        <div>Charge/Unit: <b>{modalShow.item.UnitType}</b></div>
                    </div>
                </div>
                <div className="main_content_table_history tableFixHead">
                    <DataTable
                        headers={RateCardHistoryColumns}
                        tableData={rateCardListData}
                    />
                </div>
                {isCustomService && (
                    <>
                        <h6 className="mt-3">Service type changes</h6>
                        <div className="main_content_table_history tableFixHead">
                            <DataTable
                                headers={CustomServiceChangeHistoryColumns}
                                tableData={changeHistoryData}
                            />
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    )
}

RateCardHistoryDialog.propTypes = {
    modalShow: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        item: PropTypes.shape({
            AccountingServiceMaster_Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            ServiceType: PropTypes.string,
            TransactionType: PropTypes.string,
            PackingType: PropTypes.string,
            SizeType: PropTypes.string,
            UnitType: PropTypes.string,
            IsCustomService: PropTypes.bool
        })
    }).isRequired,
    setModalShow: PropTypes.func.isRequired,
    rateCardDetails: PropTypes.shape({
        CompanySellerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
};